
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4c27ffc4&scoped=true!./css/exibirNotificacao.css")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExibirNotificacao.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4c27ffc4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExibirNotificacao.vue"),
  /* scopeId */
  "data-v-4c27ffc4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/notificacao/ExibirNotificacao.vue
// module id = 903
// module chunks = 1